import { Action, createReducer, on } from '@ngrx/store';
import * as statusSummaryActions from './status-summary.action';
import { StatusSummaryReducer } from '../status-summary.model';

const initialState: StatusSummaryReducer = {
  organizationId: null,
  deviceId: null,
};

const reducer = createReducer(
  initialState,

  on(statusSummaryActions.setOrganizationId, (state, props) => ({
    ...state,
    organizationId: props.organizationId,
  })),

  on(statusSummaryActions.setDeviceId, (state, props) => ({
    ...state,
    deviceId: props.deviceId,
  }))
);

export function statusSummaryReducer(state: StatusSummaryReducer | undefined, action: Action) {
  return reducer(state, action);
}
